import { Pin, PinFilled } from '@carbon/icons-react';
import type { ActionsOverlayAction } from 'component/actions-overlay';
import { type Comment, type CommentConfig, commentTable, type ReplyBoosterArgs } from 'component/comment';
import type { Datastore } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export const PinReplyFeature: Feature<CommentConfig, {}> = {
    name: 'Pin Reply',
    key: 'pin_reply',
    dev: true,
    providesConfig: {
        replyBooster: replyBooster,
        commentAdminActions: [getPinReplyActions],
    },
};

export function getPinReplyActions(datastore: Datastore, commentKey: string) {
    const pins = datastore.getGlobalProperty('pinned_replies') ?? {};
    const comment = datastore.getObject<Comment>(commentTable, commentKey);
    if (!comment || !comment.replyTo) {
        return [];
    }
    const isPinned = pins?.[commentKey];

    if (isPinned) {
        return [ActionUnpinReply];
    } else {
        return [ActionPinReply];
    }
}

export const ActionUnpinReply: ActionsOverlayAction<{ commentKey: string }> = {
    label: t('Pinned'),
    icon: PinFilled,
    action: async ({ datastore, commentKey }) => {
        const pins = datastore.getGlobalProperty('pinned_replies') ?? {};
        const newPins = { ...pins, [commentKey]: null };
        datastore.setGlobalProperty('pinned_replies', newPins);
    },
};

export const ActionPinReply: ActionsOverlayAction<{ commentKey: string }> = {
    label: t('Pin'),
    icon: Pin,
    action: async ({ datastore, commentKey }) => {
        const pins = datastore.getGlobalProperty('pinned_replies') ?? {};
        const newPins = { ...pins, [commentKey]: true };
        datastore.setGlobalProperty('pinned_replies', newPins);
    },
};

function replyBooster({ comments, datastore }: ReplyBoosterArgs) {
    const pins = datastore.getGlobalProperty('pinned_replies') ?? {};

    const pinnedReplies = comments.filter((comment) => pins?.[comment.key]);

    return pinnedReplies[0] ?? null;
}
